var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function HomeIcon() {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "14", viewBox: "0 0 16 14", fill: "none" }, { children: _jsx("path", { d: "M2.66669 14V7.75L1.46669 8.66667L0.666687 7.6L2.66669 6.06667V4H4.00002V5.05L8.00002 2L15.3334 7.6L14.5334 8.65L13.3334 7.75V14H8.66669V10H7.33335V14H2.66669ZM2.66669 3.33333C2.66669 2.77778 2.86113 2.30556 3.25002 1.91667C3.63891 1.52778 4.11113 1.33333 4.66669 1.33333C4.85558 1.33333 5.01391 1.26945 5.14169 1.14167C5.26946 1.01389 5.33335 0.855557 5.33335 0.666668H6.66669C6.66669 1.22222 6.47224 1.69445 6.08335 2.08333C5.69446 2.47222 5.22224 2.66667 4.66669 2.66667C4.4778 2.66667 4.31946 2.73056 4.19169 2.85833C4.06391 2.98611 4.00002 3.14445 4.00002 3.33333H2.66669Z", fill: "#2B3737" }) })));
}
